module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('a', {
    attrs: {
      "id": "title24"
    }
  }), _c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Paradoxically, academic writers are often inhibited when it comes to speaking directly, possibly because they were all little goody-goodies in junior high school, and they’re being massed together in university departments, and when you put all the smartest in the class together, there’s a tremendous anxiety about whether one can live up to the seriousness of the enterprise.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("– Terry Castle")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-517b15b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429949934_fm01.vue
// module id = 63
// module chunks = 0